import { Chip, TableCell, TableRow } from '@mui/material'
import * as React from 'react'

type Props = {
	hourLabel: string
	summary: React.ReactNode
	active: boolean // ON になり得る（有効かつ条件あり）
	enabled: boolean
	children: React.ReactNode // 編集ボタン + モーダル
}

// ヒーター/電磁弁 共通の 24時間テーブル行。ON/OFF チップ + 条件サマリ + 編集。
// スマホでも収まるよう固定列は最小幅、サマリは折り返し許容・小さめフォント。
const cellPx = { px: { xs: 0.5, sm: 1 } }

const HourlyRuleRow = ({
	hourLabel,
	summary,
	active,
	enabled,
	children,
}: Props) => (
	<TableRow
		sx={{
			bgcolor: enabled ? undefined : 'action.hover',
			opacity: enabled ? 1 : 0.75,
		}}
	>
		<TableCell
			sx={{
				...cellPx,
				fontWeight: 600,
				whiteSpace: 'nowrap',
				fontVariantNumeric: 'tabular-nums',
				width: '3rem',
			}}
		>
			{hourLabel}
		</TableCell>
		<TableCell
			sx={{
				...cellPx,
				color: active ? 'text.primary' : 'text.disabled',
				fontSize: { xs: 12, sm: 14 },
				lineHeight: 1.35,
			}}
		>
			{summary}
		</TableCell>
		<TableCell sx={{ ...cellPx, width: '3rem' }}>
			<Chip
				size="small"
				label={active ? 'ON' : 'OFF'}
				color={active ? 'success' : 'default'}
				variant={active ? 'filled' : 'outlined'}
				sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
			/>
		</TableCell>
		<TableCell align="right" sx={{ ...cellPx, width: '2.5rem' }}>
			{children}
		</TableCell>
	</TableRow>
)

export default HourlyRuleRow
